import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';
import type { State } from '../../types';

export interface AllStatesListRequestParams {
  CountryCode: string;
}

export const getAllStatesListAPI = (params: AllStatesListRequestParams) => {
  return axiosInstance.request({
    url: `${API.PRIMARY}/GetStates`,
    method: 'get',
    params,
  });
};

export type AllStatesResponse = State[];

export const fetchAllStatesList = async (params: AllStatesListRequestParams): Promise<AllStatesResponse> => {
  const response: AxiosResponse<AllStatesResponse> = await getAllStatesListAPI(params);
  return response.data;
};
